import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal } from '../../../controls/conversions';
import { formatToFractional } from '../../../controls/conversions';

const WindowWidth = ({ value, onChange, id = 'WindowWidth', label = 'Window Width', minW = 20, maxW = 200,
                       doorSizeValue = null, doorHeightValue = null, passSelectedDoor,
                       disabled = false
 }) => {
    const [selectedWindowWidth, setSelectedWindowWidth] = useState(value !== undefined && value !== null ? value : "40\"");
     const [WindowWidthError, setWindowWidthError] = useState("");

    useEffect(() => {
    validateWindowWidth(selectedWindowWidth, minW, maxW);
    }, [minW, maxW]);

     useEffect(() => {
        setSelectedWindowWidth(value !== undefined && value !== null ? value : "40\"");
    }, [value]);

     const calcWidth = (doorType, doorSize) => {
        if (doorType === 1) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 1).toString() + ' 1/2"';
        }
        if ([2, 3].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 17).toString() + '"';
        }
        if (doorType === 4) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 32).toString() + ' 1/2"';
        }
        if (doorType === 5) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2).toString() + '"';
        }
        if ([6, 7].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 17).toString() + ' 1/2"';
        }
        if (doorType === 8) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2*17 - 1).toString() + '"';
        }
        return 0;
     }
    useEffect(() => {
        if (passSelectedDoor) {
            if (passSelectedDoor.id > 4) {
                validateWindowWidth(selectedWindowWidth,minW, maxW);

            }
            else {

                validateWindowWidth(selectedWindowWidth, minW, maxW);

            }
            //alert(selectedWindowWidth);
            //validateWindowWidth(selectedWindowWidth);
        }
        if (!doorSizeValue) {
            const element = document.getElementById("DoorSize");
            if (element) { 
                doorSizeValue = element.value;
            }
        }
        if (doorHeightValue) {}
        if (passSelectedDoor && doorSizeValue) {
            //alert(JSON.stringify(passSelectedDoor, null, 2));
            const w = calcWidth(passSelectedDoor.id, doorSizeValue);
            setSelectedWindowWidth(w);
            validateWindowWidth(w);
            onChange(w);
        }
      }, [doorSizeValue, doorHeightValue, passSelectedDoor, value]); // Trigger effect whenever doorSizeValue changes

    const handleWindowWidthChange = (e) => {
        //setSelectedWindowWidth(e.target.value);
        validateWindowWidth(e.target.value);
        // Don't call onChange here - only update on blur to avoid intermediate render issues
    };

    const validateWindowWidth = (value, mmin = null, mmax = null) => {
        
        if (mmin === null) mmin = minW;
        if (mmax === null) mmax = maxW;
        const numericValue = formatToDecimal(value);
        setSelectedWindowWidth(value);
        if (numericValue && (numericValue < mmin || numericValue > mmax)) {
            console.log("minmax error: value", value, 'numericValue', numericValue, mmin, mmax);
            setWindowWidthError(`must be between ${mmin} and ${mmax}`);
        } else {
            setWindowWidthError("");
        }
    };


        
    const handleFocus = (e) => {
      let decimalValue = formatToDecimal(e.target.value);
      if (decimalValue === 0) decimalValue = "";
      setSelectedWindowWidth(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedWindowWidth(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="WindowWidth">{label}</label>
            <input
                disabled={disabled}
                id={id}
                value={selectedWindowWidth}
                onChange={handleWindowWidthChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {WindowWidthError && <p className="error">{WindowWidthError}</p>}
        </div>
    );
};

export default WindowWidth;